import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'
import { Link as LinkScroll } from 'react-scroll'
import logo from '../../images/site_logo/site_logo_2.svg'
import logo2 from '../../images/site_logo/site_logo_3.svg'
import MobileMenu from '../MobileMenu/MobileMenu'
 
const Header2 = (props) => {
 
    const [mobailActive, setMobailState] = useState(false);
 
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }
 
    const [isSticky, setSticky] = useState(false);
 
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 80) {
                setSticky(true);
            } else {
                setSticky(false);
            }
        };
 
        window.addEventListener('scroll', handleScroll);
 
        // Clean up
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
 
 
    return (
 
        <header className="site_header site_header_2">
            <div className={`header_bottom stricky  ${isSticky ? 'stricked-menu stricky-fixed' : ''}`}>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-xl-3 col-lg-2 col-5">
                            <div className="site_logo">
                                <Link onClick={ClickHandler} className="site_link" to="/">
                                    <img src={logo} alt="Site Logo – Techco – IT Solutions & Technology, Business Consulting, Software Company Site Template" />
                                    <img src={logo2} alt="Site Logo – Techco – IT Solutions & Technology, Business Consulting, Software Company Site Template" />
                                </Link>
                            </div>
                        </div>
                        <div className="col-xl-6 col-lg-7 col-2">
                            <nav className="main_menu navbar navbar-expand-lg">
                                <div className="main_menu_inner collapse navbar-collapse justify-content-lg-center" id="main_menu_dropdown">
                                    <ul className="main_menu_list unordered_list justify-content-center">
                                        {/* <li className="dropdown"> */}
                                        <li>
                                            <Link onClick={ClickHandler} className="nav-link" to="/" id="home_submenu" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                Home
                                            </Link>
                                        </li>
                                       
                                        <li className="dropdown">
                                            <Link onClick={ClickHandler} className="nav-link" to="/" id="portfolio_submenu" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                Soluções
                                            </Link>
                                            <ul className="dropdown-menu" aria-labelledby="portfolio_submenu">
                                                <li><Link onClick={ClickHandler} to="/service-single/descricao-cargos">Descrição de cargos</Link></li>
                                                <li><Link onClick={ClickHandler} to="/service-single/pesquisa">Pesquisa</Link></li>
                                            </ul>
                                        </li>
                                       
                                        <li>
                                            <Link onClick={ClickHandler} className="nav-link" to="/about" id="pages_submenu" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                Nosso propósito
                                            </Link>
                                        </li>
                                        <li><LinkScroll style={{cursor:'pointer'}} to="contactSection">Contato</LinkScroll></li>
                                    </ul>
                                </div>
                            </nav>
                        </div>
                        <div className="col-xl-3 col-lg-3 col-5">
                            <ul className="header_btns_group unordered_list justify-content-end">
                                <li>
                                    <button className="mobile_menu_btn" onClick={() => setMobailState(!mobailActive)} type="button" data-bs-toggle="collapse" data-bs-target="#main_menu_dropdown" aria-expanded="false" aria-label="Toggle navigation">
                                        <i className="far fa-bars"></i>
                                    </button>
                                </li>
                                <li>
                                    {/* <Link onClick={ClickHandler} className="btn btn-primary" to="https://proleadia.com.br">
                                        <span className="btn_label" data-text="Login">Login</span>
                                        <span className="btn_icon">
                                            <i className="fa-solid fa-arrow-up-right"></i>
                                        </span>
                                    </Link> */}
                                    <a onClick={ClickHandler} className="btnLogin btn-primary" href="https://proleadia.com.br" target="_blank" rel="noopener noreferrer">
                                        <span className="btnLogin_label" data-text="Login">Login</span>
                                        <span className="btnLogin_icon">
                                            <i className="fa-solid fa-arrow-up-right"></i>
                                        </span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="mobail-wrap">
                    <div className={`mobail-menu ${mobailActive ? "active" : ""}`}>
                        <div className="xb-header-menu-scroll">
                            <div className="xb-menu-close xb-hide-xl xb-close" onClick={() => {setMobailState(!mobailActive);
                            }}></div>
                            <nav className="xb-header-nav">
                                <MobileMenu />
                            </nav>
                        </div>
                    </div>
                    <div className="xb-header-menu-backdrop" onClick={() => setMobailState(false)}></div>
                </div>
            </div>
        </header>
 
    )
}
 
export default Header2;